import React, { useState } from 'react';

import InfiniteScroll from 'components/InfiniteScroll';
import Grid from '@mui/material/Grid';

import InfoMessage from 'components/InfoMessage';
import Snackbar from 'components/Snackbar';
import { usePermission } from 'hooks';
import CardManufacturers from './Card.js';

import api from '../../../services/apis/cooperplace';

export default function ManufacturersList() {
  usePermission('VISUALIZAR_FABRICANTES_VEICULOS', { redirect: true });
  const [snackBar, setSnackBar] = useState({
    display: false,
    type: 'info',
    message: '',
  });

  return (
    <>
      <Snackbar
        open={snackBar.display}
        type={snackBar.type}
        message={snackBar.message}
        onClose={() =>
          setSnackBar({
            display: false,
            type: '',
            message: '',
          })
        }
      />

      <InfiniteScroll
        endpoint="vehicles/manufacturers"
        initialFetch
        placeholderHeight={145}
        renderItem={(item) => <CardManufacturers manufacturers={item} />}
        endMessage={
          <Grid container item xs={12} justify="center" style={{ marginTop: '20px' }}>
            <InfoMessage
              icon="doneall"
              width="auto"
              snackColor="#8c8c8c"
              message="Não há mais itens a serem exibidos."
            />
          </Grid>
        }
        service={api}
      />
    </>
  );
}
